module.exports = __webpack_public_path__ + "9e652c74d88caa225ff11060c69ec954.ttf";


//////////////////
// WEBPACK FOOTER
// ./client/Site/Style/fonts/geo-webfont/geo-medium.ttf
// module id = 88
// module chunks = 0